
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    import {html} from 'lit';
    import {str} from '@lit/localize';

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      'backspaceKey': `⟵`,
'clearKey': `⎚ Vymazat`,
'deleteKey': `⌦ Smazat`,
'downKey': `↓ dolů`,
'endKey': `⤓ Konec`,
'enterKey': `Vstupte na`,
'escapeKey': `⎋ Útěk`,
'f10Key': `F10`,
'f11Key': `F11`,
'f12Key': `F12`,
'f13Key': `F13`,
'f14Key': `F14`,
'f15Key': `F15`,
'f16Key': `F16`,
'f17Key': `F17`,
'f18Key': `F18`,
'f19Key': `F19`,
'f1Key': `F1`,
'f2Key': `F2`,
'f3Key': `F3`,
'f4Key': `F4`,
'f5Key': `F5`,
'f6Key': `F6`,
'f7Key': `F7`,
'f8Key': `F8`,
'f9Key': `F9`,
'h64cd12550420f6f1': html`Vytvořit 
          <code>LICENCE 
          </code> soubor 
        `,
'homeKey': `⤒ Domů`,
'keyCommand': `⌘ Příkaz/Win`,
'keyControl': `^ Kontrola`,
'keyOption': `⌥ Možnost/Alt`,
'keyShift': `⇧ Posun`,
'leftKey': `← Vlevo`,
'pagedownKey': `▼ Pagedown`,
'pageupKey': `▲ Pageup`,
'rightKey': `→ Vpravo`,
's00065e45db8c0441': `Další podrobnosti naleznete v části Nástroje pro vývojáře`,
's001dd78415a91fa0': `Žlábek posuvníku`,
's002fa7d1054ed082': `Rámeček Border`,
's006f872a5b7f5279': `Sangro`,
's01b16a926920908b': `Kazachstán`,
's01b56d233c6c5cac': `Sekce`,
's01d32b35baa3b676': `Autor`,
's02106cc2ef0e7578': `Nový kolík...`,
's02ab1ea8e5100fc1': `Označit výběr jako "obousměrné přepsání".`,
's0312976fe9da5951': `Tlačítko`,
's03608a32f05eded2': `Přiblížení pomocí špetky`,
's036d35e03be98d22': `Hloubka matematiky`,
's037b1dc850a89273': `Alternativní pod`,
's0396202b716732ec': `Označte výběr jako proškrtnutý`,
's03f49e598ffb11cc': `Polský`,
's0448f1059fa01720': `Uložte, sdílejte nebo vytiskněte svůj průzkumník. Upravte informace, jako je název, jazyk nebo licence.`,
's0458872c43beadef': `Vložení řádku před`,
's04c939a414fdab21': `Tsonga`,
's050954cd4ae83304': `Mezery mezi slovy`,
's05e9759cfd99c48f': `Ospravedlnit`,
's063fa5a0a4903bf4': `Do strany, zleva doprava`,
's064339c229374050': `Kódování`,
's06634274f19b0572': `Výběr kolíků`,
's06743b24499f0035': `Kotvící centrum`,
's07808b0ca6da8fef': `Oplocené webové stránky`,
's07970793b21351fd': `Základní kontejner Ruby`,
's079cf7850d9327f0': `Písmo`,
's07aa10850d9ddcc7': `Formulář`,
's07e6118e838b2e23': `Navigace`,
's0816468df86e4036': `Otevře nastavení`,
's082869038c117fe5': `portugalština (Brazílie)`,
's086e6c267ade2609': `Nasycení`,
's08e12ade32ef8125': `Setswana`,
's08e6bd98452e6bb9': `Audio`,
's0978fb5ba3145996': `Vložení seznamu (neuspořádaného)`,
's09c3f1d21de14ae1': `Označte výběr jako podtržený`,
's0a2d91c6720033e9': `Ořezávání mezer mezi textem`,
's0a3ddcba94027d95': `Vhodnost objektu`,
's0a6cb8d42cdb0c4a': `Esperanto`,
's0a799f583098cadf': `Vložení navigace`,
's0a7db790db1fc45c': `Označit výběr jako rozpětí`,
's0b1271f50a77dc73': `Obsah boxu`,
's0b24d08ea349b455': `Vše, co lze vložit. Na začátku jsou neinteraktivní prvky, jako jsou seznamy nebo obrázky, další jsou interaktivní prvky zvané widgety. Nové můžete získat kliknutím na vyhledávací panel.`,
's0bdca49248ba4820': `Zkratky`,
's0befccf152b6c0a9': `Orientovat se podle metadat`,
's0c11e479416c8421': `Vložení nadpisu tabulky`,
's0c27336067c59611': `Výplň rolovacího okna`,
's0c4593d81f147042': `Základní údaje`,
's0c4b2e98d4ab7f5a': `Příkazy aplikace`,
's0c883713b83616a8': `Uložení aktivního dokumentu`,
's0ca5c0460199cba1': `Zkratka`,
's0cf10c4f40588f8d': `Nadpis tabulky`,
's0d86afa3c6a1e28b': `Směr Flex`,
's0dad143dff0079fc': `Malayalam`,
's0db05bd7ba6fff96': `Váš zkoumatelný dokument. Můžete zde psát text a kopírovat/vkládat, upravovat atd.`,
's0dc452999c129e15': `Povolit živé načítání`,
's0de0febab8a4beaf': `Chyba při čtení tohoto balíčku`,
's0e44968489e076a8': `Čínský`,
's0e4862e87c7d53ce': `Označit výběr jako citaci`,
's0e6ea8870dbddab2': `Příkazy dokumentu`,
's0ee28503778e4c0c': `Poslední výchozí hodnota`,
's0ef01c03299bbb83': `Dekorace`,
's0f17f32919661cff': `Mongolský`,
's0f350bc4e538e3ea': `Slova`,
's105a06836c40fcb4': `Nastavení filtrů, barev a prolínání vybraných prvků`,
's106b274b5af798e5': `Věty`,
's1082e1649793dca9': `Označit výběr jako definovaný termín`,
's10f3845975a0351e': `Úprava metadat`,
's1125d159f7e64df5': `Zobrazit`,
's11326fd2590f4e5e': `Výchozí`,
's1155ec07a221e739': `Posuvník`,
's1173bf7a3e0b74c9': `Minimum (y)`,
's1177237a3e0e548c': `Minimum (x)`,
's1219d97b49650c05': `Viditelnost`,
's123bea44f38abccf': `Vložit objekt`,
's1245e2cb9f20197e': `Zarovnat`,
's12946ec1b850962c': `Vložení sloupce za`,
's1351209ef74ee729': `Rozpětí všech sloupců`,
's13c60cb409e8cb6f': `Zarovnání na střed`,
's13ebd619c8a06a6d': `Automatické řádky mřížky`,
's13ef8ca26ca8861b': `Střihový prvek`,
's151bc2eea7a032a4': `-změněno-`,
's153bc3c3aa39587b': `Hlava stolu`,
's156647179b21d351': `Vložení těla tabulky`,
's158b6ec6b1fffcb2': `Přestávka po`,
's15d0c0657c1ee08c': `Klíč API`,
's1626a7e10a9f9dcc': `Nastaví rodinu písma výběru`,
's1637c7d1a30629e2': `Rámeček Border Box`,
's1641ab440bf4daa4': `Aktualizace tohoto balíčku widgetů`,
's166bd56d19670a72': `Zoom`,
's1696c76a23c0834e': `Pokročilé: Zobrazení balíčků s verzí 0.x.x ve správci balíčků`,
's16b9446e3a70e1f4': `Atributy`,
's16f205466761e583': `Žádné optické nastavení velikosti písma`,
's16f2f1c2c516d307': `Otevření dokumentu`,
's1749014f3f87fa6a': `Stretch`,
's17597a8bb4810524': `Licence`,
's17bfaaa4e7528bc7': `Baškirština`,
's17fb3f4805f4f4b9': `Odstranění pole`,
's181ef198cf83ec3a': `Bihari`,
's1857db526dc4dcdd': `Vytvořit balíček`,
's18d5c44aae3dc82a': `Online při úpravách`,
's1988d71ef8060edf': `Vložení řádku tabulky`,
's19abee1277c9bca2': `Samoan`,
's19daf2f26c19543d': `Náčrt`,
's1a1acc902e6668e0': `Zobrazit pokročilé formátování textu`,
's1a5230a71d9285c1': `Zachycení`,
's1aa1cb63ad44bc6f': `Mezera mezi sloupci`,
's1af8b67d1c85c811': `Prostor mezi`,
's1b4a36fce2456660': `Rodina písma`,
's1c246045629b0016': `Označit výběr jako odstranění`,
's1c3fc313a9184670': `Veřejný odkaz`,
's1c65f5004a07dcfa': `Skotská gaelština`,
's1c690963f1e2df00': `Vzhled specifický pro platformu`,
's1ca22ce85e074da5': `Pragma`,
's1d10d2058d8ca8dd': `Chcete krátkou prohlídku s průvodcem?`,
's1d19244f549ec535': `Vzdělávání`,
's1d5c7b28e8b50d6d': `Associate deg.`,
's1db591f5a54dbfd3': `Rámeček s obsahem`,
's1dbb9f50e16c92a3': `Poloměr hranice`,
's1dfb744260fb3a01': `Obousměrná izolace`,
's1e9c2c654732cc5f': `Běloruský`,
's1eaccbf2d6af8ab5': `Informace`,
's1efbfc3937d565bd': `Pozadí`,
's1f2b49c1bca2035d': `Katalánština`,
's1f74bdf32b51a5fc': `Obrázek na pozadí`,
's1f7698c061c208c9': `Otevřít`,
's1f8e59d0624842ff': `Kannada`,
's1feab14d837eadb0': `Guarani`,
's20deffeecf2699fb': `Korsičan`,
's21d61916eb8d137d': `Tělo stolu`,
's21d723a1dbcd89c8': `Javánština`,
's21f8a2eaf5a70749': `Vložení štítku`,
's2206c42e5b835e6e': `Označit výběr jako zkratku`,
's22a2348c46a912a0': `Vložení oddílu`,
's233ae776268cd44b': `Obchodní`,
's236ed7ba747099b0': `Hmotnost písma`,
's2474e7fb1aec9f05': `Test`,
's2492f5fb1b05b45e': `Text`,
's24949d7adbb5a098': `Toolbox`,
's252a52330d32b900': `Metadata`,
's2540844a4bc4d9ba': `Vyžadovat uvedení autorství?`,
's255857544a9d5ec0': `Obnovení`,
's255c77900f2b5e0f': `Barevné schéma`,
's256ab831a48c941c': `Odstraní z výběru veškeré formátování textu.`,
's2591806d7b222591': `Změny resetování`,
's25e1a07e454c2c11': `Síť`,
's262abbaf1d05f009': `Měkké světlo`,
's266935f2447fcd98': `Přes levý okraj`,
's268ecd1cef45a9a8': `Jste si jistý?`,
's2692bc028fed91f1': `⇪ Caps Lock`,
's27056379e0acfdb0': `Odlehčit`,
's27076e66c5d483ba': `Svislé zarovnání`,
's2712dc5641a33226': `Účty registru balíčků jsou určeny pro vývojáře a umožňují konfigurovat jeden nebo
          více registrů.`,
's27cc88818cc46ff6': `Stabilní`,
's281d957112b10f12': `Přímá úprava HTML dokumentu`,
's28b6246ce616a548': `Vložení skupiny sloupců tabulky`,
's29a1c26521879b9f': `Snížení měřítka`,
's29acfd2778e8c377': `Skrytí pokročilého formátování textu`,
's29b24c06315e9343': `Vložení vstupu`,
's29eb103449472e3b': `Vložení nadpisu (úroveň 3)`,
's29ee7434494a0dfe': `Vložení nadpisu (úroveň 2)`,
's29f21c34494d614d': `Vložení nadpisu (úroveň 1)`,
's29fbfc3449557f72': `Vložení nadpisu (úroveň 6)`,
's29ff743449588131': `Vložení nadpisu (úroveň 5)`,
's2a031834495bcdb4': `Vložení nadpisu (úroveň 4)`,
's2a75c946ef4dcab7': `Různé`,
's2b2ae20d26f78ac2': `Blok`,
's2b8f50c64be440f7': str`Vyberte 
          ${0}... 
        `,
's2ba5f4d8f3bd7c57': `Objednávka`,
's2bad2d24def4aa0b': `Přerušení řádku (CJK lang.)`,
's2ceb11be2290bb1b': `Zrušit`,
's2ced8e8fafb499f6': `Odstranit prvek`,
's2d986d31f8d67357': `Vložení sady polí`,
's2d995a37cf5e4995': `Vložit NoScript`,
's2de969afacdaa7a6': `Tvar`,
's2df075aface0dab8': `Sdílet`,
's2e192b19ed15fcf6': `Stránka`,
's2e39b99cf23606fa': `Nastavení rozložení vybraných prvků`,
's2e4818861000b13f': `Rozložení`,
's2e66bf8b833858f3': `Uigur`,
's2e969a451b4955d1': `Maráthština`,
's2eda5288a65bca1d': `Přetečení (y)`,
's2edd6688a65e21f0': `Přetečení (x)`,
's2f0bcdffc92a786b': `Vznášet se vpravo`,
's2f2044f2431a32d5': `Hlavička`,
's2f4d4bfbc466d91f': `Albánština`,
's2f8da2cb5f236588': `Název vašeho balíčku. Musí mít rozsah, např. \`@org/pkg\`. `,
's30cce87854901922': `Předškolní zařízení`,
's3124653c272f054c': `Barva pravidla sloupce`,
's314a4f7685c8e824': `Vždy`,
's31c06e226322f065': `Vyhněte se sirotkům`,
's323dcde72b850272': `Přístup veřejnosti`,
's32911e52ee8ac745': `Vložení slotu`,
's337a1e9022a8d19f': `Tabulka`,
's33c1450d2822bb0f': `Vložení popisku obrázku`,
's33c18d5a4cbffa2a': `Irish`,
's33f85f24c0f5f008': `Uložit`,
's342b0cabfa672822': `Pomozte uživateli najít váš widget`,
's3437e0d9899e7ae1': `Odesílání telemetrických údajů o používání aplikace WebWriter.`,
's344ea8f4939cdc98': `Barva`,
's34dcda3b0f9d5a98': `Přepínání url`,
's34f724979a124c50': `Nastaví barvu pozadí vybraného textu`,
's355b21b89ce5d9c5': `Podrobnosti na`,
's35ae5f4e0fa2777b': `Vlastní zarovnání`,
's35aeaff1425bca9e': `WebWriter nepodporuje média typu `,
's35c3125c7750681e': `Blokové citace`,
's3643189d1abbb7f4': `Kód`,
's3649bacefe731bf6': `Přepínač Toolbox`,
's365280e16a8ea32d': `Kopírování výběru`,
's366991b9c9287765': `Vpravo`,
's36a194e38d653a26': `Anotace dat`,
's36b3cefdcb897f15': `Perspektiva`,
's372fae706048ce41': `Sudé`,
's377e24af9628c37e': `Objednaný seznam`,
's37a8c35f6581da5f': `Žádná kotva`,
's37fa3b9cd51c2dfd': `Nastaví velikost písma výběru`,
's380d17664bb69531': `Vložení sloupce před`,
's3815184eb09f0dcf': `Kurzor`,
's382a2aa3984474dd': `Vytvořit`,
's38980f98cb07ceb8': `Uložit aktivní dokument jako kopii`,
's3914cb410fca44d4': `Import`,
's3a179f6db2972384': `Pozice Ruby`,
's3a5ca02f282d247e': `Sdílet...`,
's3ae67088bbefba98': `Balíčky`,
's3b0ab4b52326316f': `Světlo`,
's3b3ea038c5d3bb06': `Divize`,
's3bdad99768e11911': `Prozkoumatelné`,
's3cb47df8290fa94c': `Vložení možnosti`,
's3cf89cb47fdde7e9': `Odkaz`,
's3d09398e555ee5f9': `Rozšířené možnosti`,
's3d249bb480032121': `Seznam`,
's3d3efd1e19bdcfb4': `Anotace data/času`,
's3d6a732c792ccb9e': `Anotace Ruby`,
's3d93f9ea0c5a13fa': `Obrázek`,
's3d9548e211b958ce': `Přeskočení překryvů`,
's3e092e9d1ee2c5bb': `Klip`,
's3e78ddc9a48a608d': `Pěkné`,
's3eb6d1e6e79ed7c4': `Nebyly nalezeny žádné dokumenty`,
's3eca5a034978754b': `Odstranění výběru`,
's3f06e9abb6ebcb79': `Postavy`,
's3f1e7a3f2b283d3b': `Marže`,
's3f299e83cbf52fba': `Zhuang`,
's3f43ef2eaa1ec486': `Gudžarátština`,
's3f7e097a9b2e6181': `Vložit článek`,
's3fd83566dd643d10': `Vložení legendy`,
's3fe72792941c18f9': `Spodní část textu`,
's3ffcdc5db5e7d0c5': `Reverzní`,
's40e3826b7f74a3b5': `Pan (vpravo)`,
's40f07d7859284a44': `Dominantní základní linie`,
's4101ada154a1b958': `Střední`,
's410c465a5993f82d': `Příležitost k přerušení řádku`,
's41322d19c928c603': `ICT`,
's417b90913e05bc17': `Náhled`,
's418f2020fe996832': `Potvrzení změn`,
's41c724f0698148e9': `Označit výběr jako klávesovou zkratku`,
's41f65a763f8e44ab': `Skupina záhlaví tabulek`,
's42721130228841b0': `Rámeček pro mrtvici`,
's429bd646f1cf8bc6': `Účty Grammar LLM umožňují používat rozhraní API Grammar LLM k opravě gramatiky v textu.`,
's429dd933ba95549b': `Vložení adresy`,
's42e470ef1d707a28': `Automatické přehrávání`,
's42ffdab1291fb3de': `Vložení řádku za`,
's430831017f3f0499': `Skew (y)`,
's430bd5017f42511c': `Skew (x)`,
's433ba70286202ceb': `Přerušte všechny`,
's441b20a8a50e36b4': `Makedonština`,
's445b8acb9206db6e': `Vyřazení a zrušení`,
's446a924922651ea0': `Zvýraznění textu`,
's44cdba92713de38e': `Oblast mřížky`,
's45518abd911471d0': `Chorvatský`,
's456a8d744313852a': `Prostor kolem`,
's4634541f5056a546': `Abcházie`,
's46d4abe6255cb9e1': `Znovu přiřadit zkratku`,
's4730c232e7209c40': `Oříznutí obou`,
's474f0eec369d02a4': `Ukázka výstupu`,
's47a8f6dfb38b9701': `Telugu`,
's47e257ae643b5851': `Označit výběr jako poznámku k datu/času`,
's47ebf3a8fb3b10c1': `Orientace`,
's4802bb8eb52fbdeb': `Portál`,
's4802e47fe2e95134': `Možnost`,
's491d2919cd6ec3d9': `Hue`,
's497838412cb455f2': `Textový stín`,
's4993444bfd3f3e5e': `Sbalit`,
's49ad24935b14e3df': `Quechua`,
's49c560aecfeb8c29': `Maska`,
's49dd67aed00029ef': `Matematika`,
's49e763aed00877a8': `Hlavní stránka`,
's4a894f57eba1cf1e': `Klávesová zkratka`,
's4ac1ad6ecd6bd810': `Různé vyd.`,
's4ad6e9d3c2365c98': `Tvrdé světlo`,
's4b2c143acf931122': `Výška řádku`,
's4b58c01e2578f5e4': `Legenda`,
's4bbff4e008690da1': `Vyhnout se stránce`,
's4c1535f316305a2a': `Zkontrolujte výběr`,
's4c402ff5355fd310': `Obousměrný override`,
's4caed5b7a7e5d89b': `Angličtina`,
's4cb38675a21b2c98': `Nepodporovaný typ vlastnosti '\${desc.type}' (zpracování jako JSON)`,
's4cc8391f172c0cdf': `Ukončit prohlídku`,
's4d528b416ac8dee2': `Vložení skupiny nadpisů`,
's4d546f6c87128d5b': `Nejdříve prostor`,
's4dcb9315f6527f9c': `Spustit při opětovném načtení`,
's4e191bdb4700a6e9': `Přetáčení (x)`,
's4e1c7fdb470386ac': `Přetáčení (y)`,
's4e2562fe3990e621': `Chyba při připojování`,
's4e361bf8eef3759a': `Přestávka ve slově`,
's4ea0f21fc2a338a1': `Posun nahoru`,
's4eace13b3ed74187': `Vedlejší komentář`,
's4efee5b48a4593cb': `Smyčka`,
's4f26e7cb7c0a8318': `Vektorové kreslení`,
's4fd2e638aabb0bb3': `WebWriter podporuje vkládání mnoha různých zdrojů. Stačí vložit odkaz na obsah z:`,
's4fda04cbc245e18b': `Alpha`,
's4ffac3fb33a2ee9b': `Thai`,
's5015a8fb33b98872': `Tenké`,
's50489ffb1bde152e': `Vložení`,
's5068560b8d39663d': `Klikací mapa`,
's517acbf1f96324f9': `Hmotnost`,
's523eb9043213ff0d': `Kurzíva`,
's52777d434baeed9b': `Vložení indikátoru průběhu`,
's52af5d7ac34c2163': `Řádek tabulky`,
's52e0bdc3ee304436': `Vložení měřiče`,
's531056f039febd39': `Vložení výběru`,
's536695196d0b6dc3': `Faeroese`,
's542fcefa0bbaed86': `Otevření nebo zavření sady nástrojů (pouze na úzkých obrazovkách, jinak je sada nástrojů vždy viditelná na boku).`,
's5432ad3c84273229': `Obrázek`,
's543906d1db8b2283': `Upravit `,
's543c237e8c895ce8': `Bislama`,
's545ee1f373f249cf': `Kambodža`,
's54897f2764b0e4d0': `Instalace tohoto balíčku widgetů`,
's54cbfaf2a8da7818': `Paštúnština`,
's550839f3e4e205bb': `Označte výběr jako velmi důležitý`,
's55905c735052d295': `Tematická přestávka`,
's5590dbf7e425789d': `Štítek`,
's5623aa2f83b05c76': `Tibeťan`,
's564d1648b1ceee9f': `Aktuální`,
's565cd5ffb0158c46': `Vyhněte se oblasti`,
's571a4f19e2f140c7': `Pan (x)`,
's571db319e2f4208a': `Pan (y)`,
's575e795c45e2d97e': `Vrátit se zpět`,
's5787c6d5b3b5541a': `Cesta ke klipu`,
's579c69f419b6caef': `Hladký`,
's587ac858dd80f6fa': `Odpis`,
's58bec0ecd4f3ccd4': `Přísné`,
's59404f5593c32fdc': `Kerning písma`,
's5941292bb77281ab': `Norský jazyk Bokmål`,
's599dcd2472c75c19': `Odstavec`,
's59b20e8af32606ed': `Afar`,
's5a1a0898baf20675': `Označení výběru datovou poznámkou`,
's5a356677b61a6b7e': `Moldavsko`,
's5b474b5c0ac0c7c4': `Skupina sloupců tabulky`,
's5b517ac216f9ee62': `Sideways`,
's5b8cc9bb61ddce15': `Vložit odstavec`,
's5bba2ac2e53bd1fd': `Kirgiz`,
's5be80ad6b8301710': `Inline start`,
's5c1ecf88259b79f9': `Prezentace`,
's5c2a1a52c0389c30': `Engineering`,
's5c63af7695445fcf': `Styl textu`,
's5d18ca4c3111be6f': `Vložení záhlaví tabulky`,
's5d87c1e588f48d90': `Cvičení`,
's5d929ff1619ac0c9': `Vyhledávání`,
's5da52af9b083c29a': `Model`,
's5dc77784260a7236': `auto`,
's5e27738a2e8eb763': `Přihlásit se`,
's5e2cba97c0d971bd': `Nabíjení balíčků`,
's5e53415a6d5719ad': `Společenské vědy`,
's5e6a7a0c30d2a270': `Přeskočit překryvy (automaticky)`,
's5e9e8e4d21bafedc': `Výroba potravin`,
's5ed03bb1f3a15949': `Obrázek`,
's5f43af3669b1e098': `Zdroj:`,
's5feaf7fd7ee567c8': `Slovo zlom`,
's600fd23c9ce971e8': `Tisk aktivního dokumentu`,
's602bbd28dae2c60f': `Vlastní start`,
's60ff598dfcf2c773': `Vpravo dole`,
's61053f0e3ebbd272': `normální`,
's613c6ff83883c04f': `Sloupec tabulky`,
's6196153c4b0c1ea0': `Instalace`,
's61c017f6d5c303af': `Fríština`,
's61ded17ca3f48c82': `Posunutí podtržení`,
's61eacb19db252f5e': `ADRESA URL`,
's621ad19d35ba7742': `Výběr kopií`,
's624e31cd4f1b89d4': `Hladké posouvání`,
's626daf42b1ab7df7': `Zarovnat vlevo`,
's6280bf993915c57a': `Okraje posouvání`,
's62b857f5b6693742': `Inupiak`,
's63d894b1ddb06289': `Popis`,
's63dfc5b1c1c27849': `Jidiš`,
's63e03c70f67ebf9c': `Kontext`,
's63e71d20d1eaca93': `Němčina`,
's640bc7710d0143ce': `Znovu provést poslední zrušenou změnu v aktivním dokumentu`,
's64dc1fc7e3db45c9': `Vytvoření nového dokumentu`,
's65ac276544ba33cd': `Soubor SVG`,
's66765c420ee578e4': `Prostor rovnoměrně`,
's669b18c6d2d9c95b': `Žádné`,
's6747dbf4ad6063ba': `Vlastní konec`,
's6787497df07fa97e': `Může procházet zastávkami`,
's67c2b60a506a09e4': `Středoškolské vzdělání.`,
's680bd4d926cd5a84': `Zachovat 3D`,
's6827930ef1aeaf99': `Základní adresa URL`,
's684a16f3c711394d': `Přes pravou stranu`,
's687e27f036a71b32': `Izolovat`,
's68b87d7b61052dc3': `Řádek tabulky`,
's68e0e3a2bab7ce3e': `Vyhněte se`,
's690da6b432987c6f': `Automatické zálohování změn v aktuálním dokumentu. Změny se obnoví při opětovném načtení programu WebWriter.`,
's69311c4e25074fb3': `Střední škola`,
's697400b541fbc3cd': `Pod`,
's6988ab5d47593a26': `Máte nejnovější verzi programu WebWriter.`,
's69a49786a8009f43': `Najděte balíčky...`,
's69b12144dbb6544d': `Laothian`,
's69d88ef4b2618980': `Obálka`,
's69fbbdb8ad2a084a': `Ztmavit`,
's6a31eff1ec4f71ad': `Skrýt zadní tvář (3D)`,
's6ac62e1c8c66f3bb': `Kompaktní superscr.`,
's6b585ba37cdb8260': `Zdědit`,
's6b61f8abf89586be': `Hebrejština`,
's6bd7a02fdf93e653': `Zarovnání obsahu`,
's6cfc66b824ea05ba': `Ostré hrany`,
's6d02dc19e21eb49c': `Nahoru`,
's6d1df519e235a6cf': `Twi`,
's6d60d595cb5070da': `Vietnamci`,
's6d8b3b8047ed378d': `Režim prolnutí Mix`,
's6d8c02aee480af7a': `Nabídka`,
's6dadeaaee49d6d18': `Meta`,
's6dfb502188a8c7c2': `Vložení stylu`,
's6e288a119281f4c2': `Vykreslování textu`,
's6e4c20c6debcd5ca': `Vlastní ospravedlnění`,
's6f84199e62584905': `Předformátovaný text`,
's6fb3053e7244d326': `Ostatní oblasti`,
's70178e04a3b691b6': `Otevřít nastavení`,
's7031ca562378bde6': `Geometrická přesnost`,
's7060970b5ed20a58': `Interaktivita`,
's7136449045eff28c': `Tamil`,
's71940c32987f675f': `WebWriter Cloud`,
's71a0549fd71219c9': `Zobrazit nestabilní balíčky`,
's71dec51005acc1e4': `Řádek hustý`,
's72f2a02e2a5a4ee3': `Média`,
's730182ad28374cda': `Objekt`,
's731678e227a20559': `Toto zařízení`,
's736904f276fbd441': `Přírodní vědy`,
's739544d0c858c633': str`Nebo upusťte od 
          ${0} zde 
        `,
's73cb20c838e761e1': `Výběr střihu`,
's7417792bbe720149': `Přepracovat`,
's741fae02b3dd24f3': `Pixelated`,
's743f778233e42a3f': `Vložte poznámku stranou`,
's744d993d03f29851': `Obrazovka`,
's748c0074eff45884': `Manipulace`,
's74aa0039a87141e2': `Elipsa`,
's74b9781bacfcc87c': `Paňdžábština`,
's74cd20a7aece9b91': `Vyplňte pole`,
's75109f5307578a61': `Vítejte ve WebWriteru`,
's75a27f43413e02c5': `Francouzština`,
's75d83fc3f0cfab40': `Záhlaví`,
's762e5704cc84089d': `Nastavení dalších možností stylů vybraných prvků`,
's77318393dfdb0775': `Odstranění řádku`,
's77e594ddcc10c774': `Povolit komerční využití?`,
's782eac2b3e80323d': `Označte výběr jako zdůrazněný`,
's782f286a79cca35d': `Relativní`,
's78673a3539cb1915': `Vlevo nahoře`,
's78789724e789221c': `Velikost`,
's789ff24c8f03f1a4': `Rozteč písmen`,
's7995733bf97c01cc': `Srbochorvatština`,
's7a99528e7b64635a': `Occitan`,
's7aaf0c06e69600f1': `Chyba s `,
's7ae49e142487766c': `Přístup do Společenství`,
's7af555180b30a947': `Otevřete nástroje pro vývojáře`,
's7b4ba250601b8667': `Vložení šablony`,
's7b560d8693ed8f42': `Vzpřímený`,
's7b9994904c4f5b54': `Tádžik`,
's7bdf0fd5b014d36c': `Velký význam`,
's7beb1e77e82363eb': `Zrušení poslední změny v aktivním dokumentu`,
's7c61118554a0ec36': `Maximum (x)`,
's7c95876637f6a9d7': `Filtr`,
's7cb4e55c59663b1c': `Společnost`,
's7cfe12cd14df9950': `Odhlásit se`,
's7d27db3c9639c6dd': `Alternativní`,
's7d8103f6f06f83d6': `Vycpávky`,
's7d864465dddbb50d': `Povolit změnu velikosti`,
's7de0e28d6c309a4e': `Povolení dotykových akcí`,
's7dea785045c3cc74': `Stiskněte novou kombinaci kláves...`,
's7e0b179d4d1414eb': `Zadejte odkaz`,
's7e6570f2f1ae320f': `Syntéza písem`,
's7ecb1f29332293e5': `Základní linie vyrovnání`,
's7ed13ccddb1bf3c3': `Překrytí`,
's7edbe0b213199995': `Bakalářský titul`,
's7ede1c55e35ce9d6': `Simulace`,
's7f09197a4814079b': `Nastavení možností interaktivity pro vybrané prvky`,
's7f326a142e856656': `Styl`,
's7fcb35d23be1e643': `Sada polí`,
's80570196a9ce6d11': `Povolení telemetrie`,
's806f84eb0ace116e': `Podívejte se, co jste vybrali, a změňte to. Kopírujte, vyjměte, vložte, připněte nebo změňte rozvržení. Nabízí různé možnosti v závislosti na výběru, tj. formátování textu.`,
's80a42b81c52d4d8f': `Barva karet`,
's80b71fc6f43c5ce1': `Volné stránky`,
's812cbda653daaeba': `Tato funkce zatím není implementována`,
's814d528c8af55807': `Položka seznamu definic`,
's81c3d8809658b951': `Kašmír`,
's81cf65c5a46dea08': `Kinyarwanda`,
's81ecf2d4386b8e84': `Pokračovat`,
's8247d32213e35f24': `Vložení hlavního`,
's82665b2ffabc9c0a': `Webové stránky`,
's828b1ecea8715884': `Pánev (vlevo)`,
's833bd0422a7ef95d': `Velikost karty`,
's83420ad7b6a14db5': `Přepínání nástrojů Dev Tools`,
's83c15613b6f6f3c8': `Pouze online`,
's83cd32b685ccc9b7': `Ovládací prvky`,
's83f26d02dd7aa681': `Viditelné`,
's840fa49e8989c028': `Poloha/tvar`,
's844a76d1843ceb3c': `Obnovení výchozího nastavení`,
's84e4e8ae645b82ac': `Vpravo nahoře (y)`,
's84e9c7f8785ca60b': `Vložení formuláře`,
's8517ae4da104b004': `Skupina sloupců tabulky`,
's85186a61e0d55bac': `Video`,
's851a7deea5984646': `Licence Creative Commons OER?`,
's85f9aa6d3ea0e421': `Skupina zápatí tabulky`,
's864b0e6270e97246': `Označit výběr jako vedlejší poznámku`,
's8670e5ad3bf0dcf8': `Uložit jako`,
's8688d74dd3716d6e': `Klávesové zkratky pro příkazy`,
's86ca34c5287a2f38': `Wolof`,
's86f820d8007d0de4': `Tvarové rozpětí`,
's87cefc710b3567fb': `Obsahuje`,
's88676f992b2965db': `Roztáhnout obsah buňky`,
's886897f2fd4edb99': `Skryté stránky`,
's886c5db2a5579873': `Koncept`,
's888c71e8fcb916d3': `Automatické ukládání`,
's88a62d29529948fb': `Vložení tabulky`,
's89950d86c8004d4b': `Nepřeskočit žádné překryvy`,
's89bca7498f20e041': `Klip na pozadí`,
's8a28bad9290d4761': `Oromo`,
's8a29cb39a42f83f3': `Přestávka před`,
's8a4ff2bd9c13498c': `Záznam`,
's8a6585c48ea104e9': `Skrýt prázdné buňky`,
's8a9eb438abac7c6a': `Štítky`,
's8b0432eecbd8b034': `Aktualizace`,
's8b7580c35e2aef87': `Vlevo nahoře (y)`,
's8bc4affa761aa8a2': `Vložení obrázku`,
's8c7f51cb067644c7': `Seznam dat`,
's8d342ecaa9e75b9b': `Vztah`,
's8d797888455f4147': `Prostory pro přestávky`,
's8d83386457e91813': `Vrátit/opravit změny nebo náhled z pohledu žáka.`,
's8d8643013a7754d1': `Zarovnání textu`,
's8df30fe2a50d3479': `Vložit možnost přerušení řádku`,
's8e715248c3a78446': `Rozstříhat výběr`,
's8f29e48d6b9a1aa8': `Vložení řádku záhlaví tabulky`,
's8f4be9f086eb530f': `Zrušit`,
's8f533296a536965e': `Uložit jako...`,
's8fad58c831ecf017': `Textový kontejner Ruby`,
's8ffe7abcbed8eb43': `Svisle, zleva doprava`,
's90105521fcc40453': `Účty WebWriter Cloud umožňují ukládat dokumenty online a sdílet je se studenty.
          Přidejte si zde účet a bude k dispozici jako místo pro ukládání, načítání, sdílení a
          otevírání dokumentů.`,
's9095f01a80a91594': `Super`,
's90f0fbc12e1e2b2f': `Paleta písem`,
's90f7c1cf501ea0a7': `Barevný úskok`,
's91093e0b087911ba': `Pozice s důrazem`,
's919e1724f589c9b1': `Slot`,
's91c5ed7769d00b65': `Vložit vložit`,
's9219acd5bef6269e': `Pod levou rukou`,
's92548405912d46bf': `Zarovnání při posunu (y)`,
's9258280591309342': `Zarovnání při posunu (x)`,
's927d796559f49439': `Pozadí Původ`,
's92b177e579ef7b97': `Zdůraznění`,
's92f846b9be2e8e8d': `Označit výběr jako kurzívu`,
's93566b84230af4f5': `Vložení obrázku`,
's936aa0b239679585': `Vložení tematického zlomu (obvykle se zobrazuje jako vodorovná čára).`,
's9370dc6afa716b57': `Hranice`,
's93f083e654a45715': `Breton`,
's94653c76b2d86a04': `Definovaný termín`,
's9485af2e7cd9418f': `Základní škola`,
's94d2eee44b292567': `Přepínání pokročilých možností`,
's94d61907ee22a8c1': `Korejský`,
's94eb1effbbb6498b': `Přetečení`,
's951aa3a6439f1271': `Značka seznamu`,
's9565553d163fc92a': `Skript`,
's957787fc6b7ea5c0': `Pánev (nahoru)`,
's95c161f68e5180a5': `Zkontrolujte výběr`,
's95d56e58f816d211': `Holandský`,
's95d8e41a64635c7c': `Bílý prostor`,
's95de7e1eff6c053e': `Vodorovně, shora dolů`,
's960d3a90ac199368': `Rétorománština`,
's96532132a29dd542': `Vložení zvuku`,
's96a045dcade75ad0': `Hustý sloupec`,
's9781a5bb3fcb26a3': `Nejprve si vyberte společnost`,
's978522fbc9577a7e': `Somálsko`,
's97881699a2b21d5b': `Mezera v řádku`,
's97aa76056a81bd36': `Metriky`,
's986facb3ecc9602c': `Do strany, zprava doleva`,
's987abd19fac8cf55': `Sub`,
's9896529e5cb20558': `Externí soubor`,
's98977a87d1b93941': `Obnovení informací, stylů a skriptů`,
's990d0e0fa2ab00b5': `Galicijský`,
's99229574e5692f19': `Grónština`,
's99a990f3841ad283': `Soubory `,
's99b38e000175cc84': `Přeškrtnutí`,
's99f110d27e30b289': `Název`,
's9ab10fbf4c7a7322': `Poloha podtržení`,
's9abadcc828884d7b': `Textový prostor`,
's9b7cd8860c8fc922': str`
          ${0}
          budou přepsány. Jste si jisti? 
        `,
's9c11f2d9335d8bd1': `Oriya`,
's9c356016f81585f6': `Barva pozadí`,
's9c8df9626d152d5a': `Seznam definic Termín`,
's9ca757effd747da9': `Urdu`,
's9caf10388ab3562f': `Sloupec tabulky`,
's9cf68f87b8e6122f': `Ázerbájdžán`,
's9d167ef77aed79b6': `Vrstva`,
's9d2d00982edafabb': `Turecký`,
's9d430adc5be110e9': `Obrácená řada`,
's9d54829be67943d3': `Interlingue`,
's9d54869be6794a9f': `Interlingua`,
's9d668a34af4128ff': `Odstranění`,
's9df571714a1efb44': `K dispozici je automaticky uložená verze tohoto explorable. Načtete ji?`,
's9e28faa598332e2b': `Vložit video`,
's9e3dbb678150edd4': `Nastavení rodiny písma`,
's9e40e59654c8ad67': `Sloupec`,
's9e85800d3700e31c': `Trať`,
's9e8d3665edde89a6': `Nauru`,
's9eefe6e57e4e1661': `Varianta písma`,
's9f1ecdb3061d9cbc': `Zachovat prostory`,
's9faf26107ed49fb9': `Vložení buňky tabulky`,
's9fbe26cfd7845469': `Hausa`,
's9fc686f7bbd941e2': `Přechod`,
's9ff3121d30f88d52': `Normální`,
's9ffe1bbe64712bf1': `Plátno`,
'sa00df4e39c72d3b4': str`
          ${0} není podporován 
        `,
'sa013e119fec906fb': `Řádek`,
'sa01e7bf33563ef72': `Základní příloha`,
'sa126cf8c627cec1e': `Vykreslování obrázků`,
'sa13f72278add7513': `Vpravo dole`,
'sa1647e3b36ec08d7': `Kombinujte vzpřímeně`,
'sa172190ea21f9b1c': `Přejděte do nastavení, otevřete průzkumnou položku nebo vytvořte novou.`,
'sa1c6c459b9b5115c': `Absolute`,
'sa2cba871f6cdd99f': `Assamese`,
'sa2eff4dad1c119f1': `Šablona mřížky`,
'sa30c12014e955946': `Ruský`,
'sa30f1981fd1cd441': `Velikost písma`,
'sa311a24c1471a974': `Dokument`,
'sa352d168b262aa06': `Vložení zápatí`,
'sa37fee6a52d18063': `Odstranit dokument`,
'sa39c7ac1d37f3bce': `Označit výběr jako "obousměrný izolát".`,
'sa3b4c01623211544': `Síla`,
'sa40fd43756fa8913': `Perský`,
'sa417644bef21a9aa': `Nejmenované téma`,
'sa43800e28be1bdbc': `Barva dekorace`,
'sa477cb1825dceb3b': `Súdánci`,
'sa492a51a707930fa': `Vložení blokové citace`,
'sa4e5b39489ecf31a': `Xhosa`,
'sa4f137f8619093a5': `Titulek v dolní části`,
'sa50d3c35533f1d99': `Všechna pole`,
'sa53c5cb03a8fda50': `Připnutí výběru jako úryvku na paletě`,
'sa557ae6bee9148a6': `Progress`,
'sa589e1df65dde0ec': `Nastavení velikosti, výplně a okrajů vybraných prvků`,
'sa5c371b4bb75e590': `Vlevo`,
'sa5c80e623459ffe4': `Vložení záhlaví`,
'sa5df1bcdba46c3fb': `Obrázek Titulek`,
'sa602e3fd3f2d98fd': `Animace`,
'sa644d580d8a11e60': `Zarovnání Ruby`,
'sa645d315510dc09e': `Výběr cesty z disku`,
'sa65d4ad99f1d8c06': `Nastavení pozadí textu`,
'sa6607436f60ccc1a': `Estonština`,
'sa6f8d27bca557059': `Přesunutí prvků meta/odkazů/stylu nahoru/dolů do tohoto prvku`,
'sa757645ad842da97': `Zachovat přestávky`,
'sa75b95980cd80e78': `Editor`,
'sa7698b3d20a6d1ec': `Scroll`,
'sa778acc33947c7b8': `Dokončení prohlídky`,
'sa78a67272a4a6f95': `Matematický vzorec`,
'sa79167651dce1e80': `Alternativní text`,
'sa7af797a46c7d09a': `Zápatí tabulky`,
'sa7dbe35b758c138d': `Vložení plátna`,
'sa7dc6b8ef3f595dc': `Vložení zdroje`,
'sa8279f8211b3950d': `Zachování přestávek a prostorů`,
'sa8b55cab62e439b5': `Odstranění sloupce`,
'sa8bbe0197d31b423': `Krátký popis`,
'sa9ff3b762365abe6': `Počátek transformace (z)`,
'saa02e3762368ff35': `Počátek transformace (y)`,
'saa065776236bfa28': `Počátek transformace (x)`,
'saa33768e03c45fc8': `Velikost souboru`,
'saaad98061a20ac39': `Vložení matematického vzorce`,
'saab875d8cfcfe712': `Téma`,
'saad4380b9cc6cefd': `Střídavě nad`,
'saaec15c97a9e4245': `Obrácený sloupec`,
'sab0c57df694a0a09': `Spuštění trimování`,
'sab4d9283896d9422': `Pixely rozlišení Snap`,
'sab55faae8e165407': `Vycpávky&lt;br&gt; jako mezera`,
'sab5e7d2a069a2951': `Odborné osvědčení.`,
'sab726d2db7e6b93d': `Kirundi`,
'sac687b8649989de8': `Zarovnat vpravo`,
'sac895c732f350ac5': `Dark`,
'saced41ddda8b2354': `Flexibilní základ`,
'sad190f86451081c0': `Nepálština`,
'sad6be321164d08c8': `Kompaktní matematika`,
'sadd352cc7f6f2307': `Na okraj`,
'sae098810f946ca7c': `Tagalog`,
'sae185e6af80ec81e': `Švédský`,
'sae1c7f13b7c0c47f': `Start`,
'sae76e25497dcee58': `Recto`,
'sae9c790b88be7eb9': `Maori`,
'sae9d739068eee2c5': `Tatar`,
'saf312eaeec77a802': `Vložení seznamu popisu (slovníček, seznam pojmů)`,
'saf3da7c95cb17260': `Označte výběr jako horní index`,
'saf440a0a592f2835': `Aktualizace na`,
'saf9e5134ba1a7d30': `Scroll snap`,
'safc6f203342d09e2': `Přepne náhled aktivního dokumentu.`,
'sb0a7e3adf4a125ee': `Vpravo nahoře`,
'sb0a974028c99ca6d': `Povolit úpravy?`,
'sb0d4f0f7993cf085': `Nastavení velikosti písma`,
'sb0f3327210fe18fc': `Sloupce`,
'sb0f93c1c60c0249a': `Rubínová základna`,
'sb1494c08c8c720d1': `Nastavení barvy textu`,
'sb19611adbc88f711': `Pokročilé: Zobrazit příkazy pro úpravu zdroje, např. pro zobrazení HTML dokumentu nebo pro přidání vlastních stylů a skriptů.`,
'sb206d700d26b14ff': `Podtrhněte`,
'sb233557012dcb328': `Přesun dolů`,
'sb26035b596566abf': `Nejmenovaný`,
'sb2cda80610c8d6ea': `Prostor pro všechny`,
'sb2dc787b0983ebc6': `Litevština`,
'sb31cdff08b1c5a50': `Sindhi`,
'sb38d497d992ab4a4': `Středisko`,
'sb3ba3276ae93627c': `Vložení předformátovaného textového bloku`,
'sb430f5b4824de0d3': `Výběr rozvržení`,
'sb43db07b24da018a': `Amharština`,
'sb45f9fb4dba6e71a': `Nenastavené`,
'sb4e003a459464d85': `Kurdové`,
'sb4f0310e6787d098': `Uzbek`,
'sb4f1dffbb6be6302': `Přehledně`,
'sb51270e19988f9bd': `Region`,
'sb59d621e3c93cc27': `Sdílené hranice buněk`,
'sb5e9e1776242b028': `Interakce`,
'sb60bc1250aad44c1': `Span`,
'sb60dd9d23d31ee66': `Doktorát`,
'sb6103872073d369e': `Vložte podrobnosti`,
'sb616811735bfbafd': `Buňka tabulky`,
'sb628960829e223bb': `Přeskočit všechny překryvy`,
'sb6434faf698b02a2': `Shona`,
'sb657bfe93338dc8b': `Volapuk`,
'sb66beca1e766dcb3': `Použít a importovat`,
'sb66e2181a7b5738a': `Povolením telemetrie povolujete shromažďování a uchovávání dat podle našich pravidel.`,
'sb67e0e7c0869f982': `Rozdíl`,
'sb68e83cda6c85af8': `Záhlaví tabulky`,
'sb6b268120592dc53': `Hindština`,
'sb6ca0a8bb3caae69': `Tloušťka dekorace`,
'sb70c17f7899f9b01': `Latinský`,
'sb71941f552f3504d': `Nastavení speciální hodnoty`,
'sb740eab4afd5a710': `Automatický tok sítě`,
'sb741b6e0ca589122': `Vrátit vrstvu`,
'sb7c77d0415de05cf': `Provádění testů`,
'sb7fb7568f6883ab8': `Sdílení aktivního dokumentu`,
'sb85774dc5d18ff0f': `Potvrďte`,
'sb85b1e36579852a6': `Neplatný e-mail nebo heslo`,
'sb884fa76bfc55429': `Arabština`,
'sb8a3d4df7d1c5e6b': `Bilance`,
'sb8f610a0e8df91fc': `Svítivost`,
'sb8f855b49234b81b': `Použít`,
'sb905da066c10182c': `Navíc tmavší`,
'sb940ade1bd81be7e': `Pod levou rukou`,
'sb9e9a7dd45966756': `Označte výběr jako tučný`,
'sba509fd8ed61d1d5': `Neuložený soubor`,
'sba64d8954d027206': `Neprůhlednost`,
'sba88d90cd6c751b3': `Pravidlo sloupce`,
'sbaf0a7c417e388af': `Zdraví`,
'sbb15d427ee1aa676': `Tigrinya`,
'sbb34f2e3aa40af4e': `Tonga`,
'sbb55f9f2d69fd327': `Filtr na pozadí`,
'sbb85a407d730e13d': `Vložení vyhledávání`,
'sbb86c6c96f598bb8': `Smíšené`,
'sbba0156f795d8c07': `Upravit výběr`,
'sbba865d4b437944f': `Atribut`,
'sbbe639e3a3ed95d1': `NoScript`,
'sbc5bb5bb74d141b9': `Odinstalujte stránku`,
'sbc5f2a81604baf9b': `Hlava 6`,
'sbc5f2b81604bb14e': `Hlava 5`,
'sbc5f2c81604bb301': `Hlava 4`,
'sbc5f2d81604bb4b4': `Hlava 3`,
'sbc5f2e81604bb667': `Hlava 2`,
'sbc6953a36ced943f': `zásady ochrany osobních údajů`,
'sbd181cd54b8402a4': `Upravit výběr`,
'sbd35ee879d9cf770': `Rubínový text`,
'sbd40f40cbadd38d5': `Odstranění tohoto balíčku widgetů`,
'sbd72dc858de95ce8': `Barmský`,
'sbe3c60c65f129daa': `Humanitní vědy`,
'sbe4a7c8f231739b3': `nebo vložit/vysadit/vyzvednout soubor`,
'sbe90de083557ef3e': `Svahilština`,
'sbefb6064cba01844': `Vložení zlomu řádku`,
'sbf00e1ee999ea94e': `Vložení skriptu`,
'sbf519920c2017d67': `Zavěšení`,
'sbfa01f189a68d3e9': `Flex grow`,
'sbff54e740c4086eb': `Zobrazit neznámé balíčky`,
'sbfff51feacf30196': `Sanskrt`,
'sc0ceaa9843510f67': `Turkmen`,
'sc1611c0558728a2a': `Pozice`,
'sc1a155cc25899250': `Skupina řádků tabulky`,
'sc1aa1f6051b7102a': `Rumunština`,
'sc1edebeaef92b7bd': `Pevné rozložení tabulky`,
'sc1fff4f356dfb2fb': `Transformovat`,
'sc24bda3c061fddf8': `Klikatelná oblast`,
'sc252a4e091763606': `Vložení zápatí tabulky`,
'sc2536e077514accc': `Rolování`,
'sc275dd00036d16cb': `Citáty charakter`,
'sc28864200d2a3799': `Kopírování kódu QR jako obrázku`,
'sc2a24a9dd41a9503': `Linka dekorací`,
'sc2b734cca2fa643b': `Pan (dolů)`,
'sc2e2a0dbf03723b7': `Pokročilé: Zobrazit balíčky z neznámých zdrojů ve správci balíčků (Varování: Může být nebezpečné)`,
'sc3998b77d72c2932': `Vložení webové stránky (jako inline rámeček)`,
'sc3ac225273c8316b': `Obecné`,
'sc3cfee84dbbf36ae': `Místní soubor`,
'sc3f09a9b6fa4fbed': `Uvnitř`,
'sc43767deea72e9f3': `Seznam popisů`,
'sc462bbdd36bcba6b': `Referenční rámeček`,
'sc4ee3e4ee994dafd': `Ukrajinský`,
'sc50d09edf9325339': `Dialog`,
'sc52b67794c06a0d3': `Perspektivní počátek (y)`,
'sc52e8b794c0913d6': `Perspektivní počátek (x)`,
'sc53de149fcaad713': `Mezi postavami`,
'sc546f489f9c0cced': `Přepne testovací režim pro aktivní dokument.`,
'sc5bcf50d1b578d9f': `Nastavení funkce písma`,
'sc5cb39478b9b7625': `Označit výběr jako index`,
'sc6415b50ff928294': `Položka seznamu`,
'sc650ff15b20fe9d3': `Otáčení (z)`,
'sc6578b15b2154365': `Otáčení (x)`,
'sc65aff15b2183e58': `Otáčení (y)`,
'sc6da0f4a7e4d710e': `Přepsání jazyka písma`,
'sc74e3567875ce255': `Značka widgetu i název balíčku NPM`,
'sc7eb080b96e244df': `Malajština`,
'sc8ac7ef92b95df3f': `Přesun (x)`,
'sc8af536e2084ade0': `Paleta`,
'sc8b022f92b992bc2': `Přesun (y)`,
'sc8b39af92b9c2d81': `Přesun (z)`,
'sc8d2c7f6c33a2b32': `Nastavení stylu textu (zarovnání, odsazení, mezery atd.) vybraných prvků`,
'sc8fa0e3de389ef1c': `Nastavení velikosti písma`,
'sc9474bf7a0668d73': `Souhrn`,
'sc94e314312a8900c': `Česky`,
'sc980855a000b76ea': `Spodní část`,
'sc98b103772de63f4': `Finsko`,
'sca7cfe2bef51b2a5': `Kořen`,
'sca7fed2bef53cb99': `Role`,
'scabe6ecee5e01fd2': `Maltský`,
'scace301a88231cce': `Vložit`,
'scbc55f622ec078c1': `Zobrazit box`,
'scbe537fc38ff4c13': `Automatické sloupce mřížky`,
'scc1db59d292cbc4c': `Sekce`,
'scc56b218a2689c42': `Arménština`,
'scc5ba32e0de06744': `Sesotho`,
'scd15088c39fe9edf': `Políčko pro vycpávky`,
'scd9cedeb5ece3adb': `Spojovník`,
'scdf536b65be39ec5': ` Vytvořit/importovat`,
'sce8a4e3f7c98482d': `Siswati`,
'scec2be75ee985f6c': `Ideografické`,
'sceecdd0bb404bc17': `Vložení skupiny možností`,
'scf00d48fd5953a03': `Řecký`,
'scf932840a69dbb7c': `Portugalština`,
'scf932a8577057752': `Zápatí`,
'scf95dcb12a950a5c': `Aymara`,
'scfcb70f2a15eaf14': `Vpravo dole`,
'sd01178c54f648118': `Sloupce bilance`,
'sd03bff50f87f82d4': `Znak s pomlčkou`,
'sd05a155fe09c2866': `Online při použití`,
'sd0864ea6cb6ef22e': `Společenství`,
'sd10fdbe6caf9a998': `Přerušení řádku`,
'sd121d3b959b7888d': `Optimalizace rychlosti`,
'sd1a78e667a1a139f': `Označit výběr jako vložení`,
'sd1cffad290ea5b3b': `Ponechte si všechny`,
'sd1f10284eeb17b25': `Fidži`,
'sd1f44f1a8bc20e67': `E-mail`,
'sd1f81984eeb7c0e8': `Naplňte`,
'sd29dc07235eea0f5': `Citace`,
'sd2addf69477cd4b4': `Importní balíček`,
'sd2ed26defc646d47': `Filtr na pozadí`,
'sd2ef82b8ea877c6d': `Afrikánština`,
'sd319aae1401f1e19': `Opraveno`,
'sd3a288c1094b8a63': `Šířka pravidla sloupce`,
'sd3c65ef5c380c046': `Vložka`,
'sd3dcb76f7b28adb8': `Lotyšský`,
'sd3eca1e0f4209f6e': `Oříznout vše`,
'sd3f402df8619ddcd': `Tyto informace o vás se automaticky přidávají do nových dokumentů. U každého
          dokumentu je můžete změnit v editoru metadat.`,
'sd4368b12645d3c0f': `Vložení portálu`,
'sd452cebf4a0313d1': `Zobrazit příkazy pro úpravu zdroje`,
'sd48cc52117f4d68b': `Italský`,
'sd52660ee947ca58b': `Vložení sloupce tabulky`,
'sd588d17a1b25c220': `Přetečení textu`,
'sd5be6f6d85fc0c9b': `Zulu`,
'sd5bf67958b08b4cf': `Vyšší vzdělávání.`,
'sd5cf95145e4d89ca': `Zrušení připnutí tohoto úryvku`,
'sd5fd9d11a92f5b1d': `Vlevo dole (y)`,
'sd60c9bbc51375635': `Vložení tlačítka`,
'sd66c4767fa3dde28': `Barva akcentu`,
'sd679c8b1bf8cc8a5': `Malé kapitálky`,
'sd7086c4425c53c80': `Rodina písma`,
'sd837f42ac7cbfb58': `Tvar (vnější)`,
'sd88076d2994ee0fb': `Vyloučení`,
'sd89a2e529b31ef43': `Vrátit`,
'sd8a345e95668b73b': `Vertikální, zprava doleva`,
'sd8ce9e57270b030d': `Roztažení písma`,
'sd8ecf227c7c49331': `Matematické`,
'sd8f923198e0c5c6a': `Konec`,
'sd9c21e5f60d6bdd8': `Dánský`,
'sd9ff8e2612e63d50': `Velikost rámečku`,
'sda2d76b976502a8d': `Otevřete...`,
'sda344aacb837387e': `Poloha v kontejneru`,
'sda5b6fa8b771f996': `Plovoucí vlevo`,
'sda9254d1f1228e1a': `Maďarština`,
'sdb1595f5c742dfbb': `Vstup`,
'sdb711380a28fec75': `Vložení seznamu (uspořádaného)`,
'sdb73788b3c975f16': `Auto`,
'sdbee7e0523a23a42': `Vpravo dole (y)`,
'sdc48456f9a27ae02': `Generátor`,
'sdc70d81cf6c28533': `Gruzínština`,
'sdd1ff479d04ac140': `Veřejnost`,
'sdd2fc8919a9c3111': `Režim prolnutí pozadí`,
'sdd35b688281b6dea': `Japonský`,
'sddc49047f66a64ab': `Není uveden žádný popis`,
'sdef34fe08bb28b09': `Čínština (zjednodušená)`,
'sdf62e305e1594805': `Označení výběru rubínovou poznámkou`,
'sdf946172dfa0328f': `Superscript`,
'sdf9bc5d9b7f3e3de': `Zarovnání`,
'se036b53f145441cd': `Smíšený obsah`,
'se06f459fccdc3ce9': `Zarovnání posledního řádku textu`,
'se0a782a8be8e018b': `Norština`,
'se0cda6b80a1bb50f': `Slovenská`,
'se0f67eae944f8f94': `Ztlumit`,
'se1312d6528f9a259': `Yoruba`,
'se16c5e66886fbc59': `Článek`,
'se1f5bb0386c88f96': `Nastaví barvu vybraného textu`,
'se219da7b1e955c65': `Jasné formátování`,
'se25e4f2cb77b8be8': `Jazyk pro rozhraní WebWriter a nové dokumenty`,
'se2796c5824ec8916': `Viditelnost obsahu`,
'se308836a594808b6': `Singhálština`,
'se36c5b1baf5e0660': `Kdekoli`,
'se39c065efa467782': `Baskicko`,
'se3b4c857f91f80d7': `Klávesové zkratky`,
'se47baf2fd16b9d2b': `Šablona`,
'se48bd9e6c2a3109d': `Účty`,
'se58467472725ad0c': `Rozlišení obrazu`,
'se58f06c2b0583ff7': `Vybrat souřadnice`,
'se5dc1e97fb743ade': `Rozestupy`,
'se619a501d1bfe6a5': `Wrap`,
'se62385ac082368d2': `Označte výběr jako zdroj citací`,
'se6297163cac9d276': `Upravit zdroj`,
'se633223a0b88625e': `Umístění buněk`,
'se638417c560cfe5c': `Vniknutí dovnitř`,
'se64f418b4e733b6c': `Vložení výstupu`,
'se6cdad455e2d8c02': `Vložení rozdělení`,
'se79c0a3ac70d8fb3': `Asp. poměr (x)`,
'se79fae3ac710dc36': `Asp. poměr (y)`,
'se7fad370d8fb4cec': `Optimalizace čitelnosti`,
'se8a94b4effa2033e': `Abecední`,
'se95d4e55ea186d9a': `Barva posuvníku`,
'se96d43a515b8451c': `Slovinština`,
'se96fd76ba1b2975a': `Centrální`,
'se9ac05f36b004eb0': `Skrýt úvodní prohlídku. Zakázat, aby se prohlídka znovu zobrazila.`,
'se9b1fec72ffd8f48': `Místní`,
'sea24bdcaa2bd2dec': `Povinné snímání`,
'sea52df2b70a5c10d': `Ruby`,
'sea6e7291e27ec53f': `Přepne editor metadat`,
'sea896ed51ad33287': `Nejsou k dispozici žádné specifické styly`,
'seaaaeb09e3b4e78b': `Příkazy pro úpravy`,
'seabae79729c4b2ad': `Přepínání e-mailu`,
'seaecc8267bad6234': `Střední škola`,
'seaf97719986faf4f': `Mezera`,
'seb19675a580f0628': `Vyhnout se sloupci`,
'seb4e52ef5ec7a7dc': `Barvy/efekty`,
'seb8982ae8c3cdcc5': `Indonéský`,
'sebbced89e0db2894': `První základní linie`,
'sec02109a0dd2a6c8': `Zvýraznění barvy`,
'sec2557a35b702525': `Proměnná`,
'sec2da4aa7a02b925': `Islandské`,
'sec30fbb20f102670': `Vložte shrnutí`,
'sec8b0b6c729816b6': `Skupina záhlaví`,
'seccd05955adb76bc': `Plakát`,
'sed17285cd25d6389': `Adresář, ve kterém se nachází soubor package.json`,
'sed318ec045c5144f': `Více než`,
'sed713f1b916fb469': `Rozteč okrajů (x)`,
'sed74a31b9172942c': `Rozteč okrajů (y)`,
'sed86bd0deb2e5372': `Transformovat text`,
'see2fcaedf9743ec6': `Umístění`,
'seec6798afe90ffc8': `Tisk`,
'sef00c258bc1ecf1e': `Tento průzkumník má neuložené změny.`,
'sef23dd271edd4a8b': `Vlevo dole`,
'sef24caccbd4645ef': `Smršťování Flex`,
'sef49aec68fd1dc66': `Název`,
'sef73fe18e351eb35': `Klíčová slova`,
'sef75f458d77491af': `Skupina možností`,
'sefcf950b3cc4fc3b': `Jazyk`,
'sf0c8e2b013e5ff18': `Bhutani`,
'sf0ca10f343249063': `Obsah`,
'sf0cab2483f66aa2e': `Vlastní`,
'sf0e261e04eda82ff': `Vzhled`,
'sf1045382c1fd9a85': `Přesné barvy tisku`,
'sf14c35392ec7bf10': `Tato funkce není ve Firefoxu k dispozici. Je dostupná v prohlížečích Chrome a Edge.`,
'sf14f9d5f9f6ca342': `Plus lehčí`,
'sf1868dc19e3917bb': `Španělština`,
'sf190149f9d8bbb2a': `Režim psaní`,
'sf1e79171c4856543': `Jste si jistý? Tuto akci nelze vrátit zpět, všechna vaše nastavení budou smazána a
          resetována.`,
'sf21c1f60c7515f44': `Označit výběr jako výstupní vzorek`,
'sf21fb4f4b9e8911f': `Šířka`,
'sf22a3737146ec910': `WebWriter umí vkládat SVG přímo do dokumentu.`,
'sf2514d5dc78b1654': `Vložení widgetu`,
'sf28903d4ca0ddcfc': `Odstranění tohoto účtu`,
'sf2ab37af0abc55ef': `Skrýt úvodní prohlídku`,
'sf2bdb0b4d7b9c039': `Bengálština`,
'sf2cbb5e519264e67': `Změna velikosti ve vodorovném i svislém směru`,
'sf2d5cbc2fe0ad65a': `Sticky`,
'sf2d96d0eb32cb81f': `Kompozice animace`,
'sf2de3dbe2108637a': `Vykreslování tvarů`,
'sf2e08a945e9194d4': `Welch`,
'sf34696c526e810b4': `Inline`,
'sf39736a666dbb038': `Vložení stopy`,
'sf3c4da68b08a2590': `Madagaskar`,
'sf471ec2496f904cc': `Vyřazení změn`,
'sf4849bc200e279ed': `Nadpis tabulky`,
'sf486ca1fdbe08645': `Vložení obrázku`,
'sf4b537d4cbd8f5fd': `Text nahoře`,
'sf4e0e02a5277ef23': `Vložení textového pole`,
'sf4f067d41efd4b83': `Měřítko (y)`,
'sf4f3cbd41f002b46': `Měřítko (x)`,
'sf4fa67d41f05a008': `Měřítko (z)`,
'sf5197db2d5f2926a': `Rotace`,
'sf52d840949a980d1': str`
          ${0}
          budou trvale odstraněny. Jste si jisti? 
        `,
'sf55d634dcc743595': `Služby`,
'sf59c9081d106dd9c': `Označit výběr jako proměnnou`,
'sf5e76f774beb33c2': `Inuktitut`,
'sf64a8229a8136552': `Odstranění dokumentu`,
'sf65df67a03bebe4b': `Povinné pro tento widget`,
'sf6673729c03ae999': `Resetování nástroje WebWriter`,
'sf67571992e7dc88e': `Celý termín`,
'sf6b4934598f7ed10': `Povolit výběr`,
'sf6e1665c7022a1f8': `Heslo`,
'sf79e0d78b56444f1': `Inline konec`,
'sf7a5f7a7c80c3082': `Obě stránky`,
'sf7c0eba7c822e3d6': `Odvážný`,
'sf86bd4d2982f3b74': `Označit výběr jako kód`,
'sf8e82313fa411494': `Označit výběr jako odkaz`,
'sf955eff73fb6b573': `Srbština`,
'sf9929e2d356260c5': `Násobit`,
'sf993bb199fefbe04': `Všechny`,
'sf9ecf969dd4b8164': `Oba okraje`,
'sf9f2c719a04066ec': `Aplikace`,
'sfa49a5bb1a5d353e': `Soukromý přístup`,
'sfa59c7777e2a0eeb': `Vložení seznamu dat`,
'sfaa0a67db5c11f72': `Odsazení prvního řádku textu`,
'sfb231a52211b133f': `Žádné obtékání textu`,
'sfb68cae41d749423': `Úvodní stránka`,
'sfb9b6edb0ed378c9': `Zdroj citací`,
'sfbbab09dbe553571': `Vložení vektorové kresby (SVG)`,
'sfc00292e778b67e2': `Měřič`,
'sfc63e31ac7c956ed': `Vyberte`,
'sfc815c9078bba30a': `Stáhnout kód QR jako obrázek`,
'sfcdd8e672c75b713': `Adresa`,
'sfcebd18506f1e535': `Průtok`,
'sfd0cde85070d2eb2': `Flex`,
'sfd77270c3f54f664': `Výstup`,
'sfdb1e4d90981a535': `Sdílet tento dokument`,
'sfdeef3dccf409f81': `Toto klíčové slovo je vyžadováno pro widgety.`,
'sfe6e758ad2603c1d': `Magisterský titul`,
'sfee1c12daf838935': `Vypalování barev`,
'sff303daee4dd9f7b': `Lingala`,
'sff3df0c2823ec6e4': `Verso`,
'sff99962304ac7d25': `Vložení dialogového okna`,
'sffa395f64ec6ac36': `Bulharský`,
'sffdadf0a576fd802': `Výška`,
'spaceKey': `Prostor`,
'tabKey': `⭾ Karta`,
'upKey': `↑ Nahoru`,
's2739460e44320108': `Chinese (Traditional)`,
'scbf29ce484222325': ``,
    };
  